import { IEnvironment } from "./environment";

export const localEnv: IEnvironment = {
  env: "local",
  api: {
    protocol: "http",
    host: "localhost",
    port: "8080",
  },
  oidc: {
    clientId: "323878981155749894@auroradms",
    issuerEndpoint: "http://localhost:8081",
    loginCallbackUrl: "http://localhost:3000/code",
    authorizationEndpoint: "http://localhost:8081/oauth/v2/authorize",
    scope: "openid profile email urn:zitadel:iam:user:metadata",
    keyListEndpoint: "http://localhost:8081/oauth/v2/keys",
    userInfoEndpoint: "http://localhost:8081/oidc/v1/userinfo",
    roleFieldName: "urn:zitadel:iam:org:project:323878671330836486:roles",
    endSessionEndpoint: "http://localhost:8081/oidc/v1/end_session",
  },
  modulesEnabled: {
    archive: true,
    digitalSignature: true,
    qualifiedDigitalSignature: true,
    tasks: true,
    sefProvider: true,
    emailListenerProvider: true,
    networkShareProvider: true,
    ocr: true,
  },
  documentTableColumns: {
    userName: false,
    description: true,
    creationDate: true,
    archiveDate: false,
    documentType: true,
    documentStatus: true,
    tags: true,
  },
};
